const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.numberCount();
    },

    numberCount: function() {
        $('.count').each(function() {
            $(this).prop('Counter', 0).animate({
                Counter: $(this).text().replace('+' , 'k')
                // Counter: $(this).text()
            }, {
                duration: 2500,
                easing: 'swing',
                step: function(now) {
                $(this).text(Math.ceil(now));
                }
            });
        });
	}
}

export default _this;